/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressV1Dto } from '../models/AddressV1Dto';
import type { CreatePointOfSaleV1Dto } from '../models/CreatePointOfSaleV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { OrderByRelationalPropertyDto } from '../models/OrderByRelationalPropertyDto';
import type { PatchPointOfSaleV1Dto } from '../models/PatchPointOfSaleV1Dto';
import type { PointOfSaleDetailV1Dto } from '../models/PointOfSaleDetailV1Dto';
import type { PointOfSaleFilterInnerV2Dto } from '../models/PointOfSaleFilterInnerV2Dto';
import type { PointOfSalePaginatedV2Dto } from '../models/PointOfSalePaginatedV2Dto';
import type { PointOfSaleSimplePaginatedV2Dto } from '../models/PointOfSaleSimplePaginatedV2Dto';
import type { PointOfSaleV1Dto } from '../models/PointOfSaleV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PointOfSalesService {
  /**
   * @returns PointOfSaleV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleControllerV1FindAllV1(): CancelablePromise<Array<PointOfSaleV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sales',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns PointOfSaleV1Dto create entity
   * @throws ApiError
   */
  public static pointOfSaleControllerV1CreateV1(
    requestBody: CreatePointOfSaleV1Dto,
  ): CancelablePromise<PointOfSaleV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/point-of-sales',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static pointOfSaleControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/point-of-sales',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleId
   * @returns PointOfSaleDetailV1Dto the entity
   * @throws ApiError
   */
  public static pointOfSaleControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<PointOfSaleDetailV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sales/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleId
   * @param requestBody
   * @returns PointOfSaleV1Dto the update entity
   * @throws ApiError
   */
  public static pointOfSaleControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchPointOfSaleV1Dto,
  ): CancelablePromise<PointOfSaleV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/point-of-sales/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleId
   * @returns PointOfSaleV1Dto the entity
   * @throws ApiError
   */
  public static pointOfSaleControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<PointOfSaleV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/point-of-sales/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param customerId customerId
   * @returns PointOfSaleV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleControllerV1FindManyByCustomerIdV1(
    customerId: string,
  ): CancelablePromise<Array<PointOfSaleV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sales/by-customer/{customerId}',
      path: {
        customerId: customerId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param contractId
   * @returns PointOfSaleV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleControllerV1FindByContractIdV1(
    contractId: string,
  ): CancelablePromise<Array<PointOfSaleV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sales/by-contract/{contractId}',
      path: {
        contractId: contractId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleId
   * @returns AddressV1Dto a entity list
   * @throws ApiError
   */
  public static pointOfSaleControllerV1FindManyAddressesByPointOfSaleIdV1(
    uuid: string,
  ): CancelablePromise<Array<AddressV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/point-of-sales/{uuid}/addresses',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleId
   * @param addressUuid addressesId
   * @returns AddressV1Dto create entity
   * @throws ApiError
   */
  public static pointOfSaleControllerV1LinkAddressToPointOfSaleV1(
    uuid: string,
    addressUuid: string,
  ): CancelablePromise<AddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/point-of-sales/{uuid}/addresses/{addressUuid}',
      path: {
        uuid: uuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid pointOfSaleId
   * @param addressUuid addressesId
   * @returns PointOfSaleV1Dto the entity
   * @throws ApiError
   */
  public static pointOfSaleControllerV1UnlinkAddressToPointOfSaleV1(
    uuid: string,
    addressUuid: string,
  ): CancelablePromise<PointOfSaleV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/point-of-sales/{uuid}/addresses/{addressUuid}',
      path: {
        uuid: uuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param orderBy Array of PointOfSaleBaseV2Dto order by properties (supports relations with dot-notation)
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying Point of Sales
   * @param searchString A search string to filter PointOfSaleV2Dto by given values.
   * @param contractId Filter points of sale by contract ID
   * @returns PointOfSalePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static pointOfSaleControllerV2FindAllV2(
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: PointOfSaleFilterInnerV2Dto | null,
    searchString?: string | null,
    contractId?: string,
  ): CancelablePromise<PointOfSalePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/point-of-sales',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        contractId: contractId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param orderBy Array of PointOfSaleSimpleV2Dto order by properties
   * @param filter Filter conditions for querying Point of Sales
   * @param searchString A search string to filter PointOfSaleSimpleV2Dto by given values.
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param contractId Filter points of sale by contract ID
   * @returns PointOfSaleSimplePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static pointOfSaleControllerV2FindAllSimplifiedV2(
    orderBy?: Array<OrderByPropertyDto> | null,
    filter?: PointOfSaleFilterInnerV2Dto | null,
    searchString?: string | null,
    page?: number,
    limit?: number,
    contractId?: string,
  ): CancelablePromise<PointOfSaleSimplePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/point-of-sales/simple',
      query: {
        orderBy: orderBy,
        filter: filter,
        searchString: searchString,
        page: page,
        limit: limit,
        contractId: contractId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
